import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { DateSettings } from 'src/Libs/system-data-handler/types'
import { useCostSavingsChartData } from '../../hooks/use-cost-savings-chart-data'
import ChartContainer from './ChartContainer'
import { useNewRelic } from '@e3dc-react/shell/Libs/observability-tool'
import { ChartHeaderPrintDownload, useChartDateBarContext } from 'src/Libs/chart-kit'
import { useChartEventsAndZoom } from '../../hooks/cost-saving-chart'

/**
 * Contains all relevant components to display the electricity chart and it's functionalities
 */
const CostSavingChartWrapper: React.FC = () => {
  const { pageActions } = useNewRelic()
  const [showLegend, setShowLegend] = useState<boolean>(true)
  const { from, to, view, resolution, setFrom, setTo, setView, isForecastEnabled } = useChartDateBarContext()
  const dateSettings: DateSettings = {
    from,
    to,
    view,
    resolution,
    setFrom,
    setTo,
    setView,
    isForecastEnabled,
  }

  const { data, loadingState } = useCostSavingsChartData(resolution ?? 'day', dateSettings?.from, dateSettings?.to)

  const toggleLegendVisibility = (): void => {
    setShowLegend(!showLegend)
  }

  useEffect(() => {
    if (dateSettings?.view) {
      pageActions.componentClicked({ componentName: 'CostSavingChart', elementName: `${dateSettings.view}SelectButton` })
    }
  }, [dateSettings?.view, pageActions])

  const { zoomedData, chartEventHandlers, resetZoom, zoomStartIndex, zoomEndIndex, isZoomedIn, zoomedFrom, zoomedTo } = useChartEventsAndZoom(
    data ?? []
  )

  return (
    <Box
      sx={{
        paddingInline: {
          sm: 0,
          md: 2,
        },
      }}
    >
      {dateSettings && (
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, ml: { xs: 0, sm: -2 }, mt: { xs: 2, sm: 0 } }}>
          <Box
            sx={{
              width: '100%',
              minHeight: '100%',
              pr: { xs: 0, sm: 2 },
              pl: { xs: 0, sm: 2 },
              pt: { xs: 0, sm: 2 },
            }}
          >
            <Box sx={{ mb: 6 }}>
              <ChartHeaderPrintDownload
                isZoomedIn={isZoomedIn}
                showLegend={showLegend}
                toggleLegendVisibility={toggleLegendVisibility}
                resetZoom={resetZoom}
              />
            </Box>
            <ChartContainer
              dateSettings={dateSettings}
              data={zoomedData ?? data}
              loadingState={loadingState}
              showLegend={showLegend}
              chartEventHandlers={chartEventHandlers}
              zoomStartIndex={zoomStartIndex}
              zoomEndIndex={zoomEndIndex}
              isZoomedIn={isZoomedIn}
              zoomedFrom={zoomedFrom}
              zoomedTo={zoomedTo}
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default CostSavingChartWrapper
